// GCCV2EmotionalIntelligenceResult.tsx
import React from "react";
import GCCV2TabDashboard from "./GCCV2TabDashboard";
import { getGCCV2StrictLanguageInstruction } from "../../../utils/GCC/astriaGCCV2Language";

const PROMPT = {
  en: (dob: string) =>
    `Give me my GCC Emotional Intelligence reading for today — my current emotion, regulation, expression, and awareness, with a few micro insights.\nDate of Birth: ${dob}\n${getGCCV2StrictLanguageInstruction("en")}`,
  ar: (dob: string) =>
    `أعطني قراءة "الذكاء العاطفي" الخاصة بي اليوم — حالتي العاطفية الحالية، وتنظيمها، والتعبير عنها، والوعي بها، مع بعض الرؤى الدقيقة.\nتاريخ الميلاد: ${dob}\n${getGCCV2StrictLanguageInstruction("ar")}`,
};

const GCCV2EmotionalIntelligenceResult: React.FC = () => (
  <GCCV2TabDashboard
    tab="emotional"
    tabKey="emotional"
    subCategoryMatch="emotional"
    buildPrompt={(dob, language) => PROMPT[language](dob)}
    title={{ en: "Emotional Intelligence", ar: "الذكاء العاطفي" }}
    subtitle={{
      en: "Your current emotion, regulation, expression, and awareness.",
      ar: "حالتك العاطفية الحالية، وتنظيمها، والتعبير عنها، والوعي بها.",
    }}
  />
);

export default GCCV2EmotionalIntelligenceResult;
